import RegisterAdmin from "./RegisterAdmin";
export default RegisterAdmin;